export default function (pan) {
  try {
    return pan.match(/.{1,4}/g).join(' ')
  } catch (error) {
    return pan
  }
}
